import React from "react";

const MixedSlider = () => {
	return <h1>Mixed Slider</h1>;
};

export default MixedSlider;
